import { render, staticRenderFns } from "./CardGroupPage.vue?vue&type=template&id=4a88b8b7&scoped=true&"
import script from "./CardGroupPage.vue?vue&type=script&lang=js&"
export * from "./CardGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./CardGroupPage.vue?vue&type=style&index=0&id=4a88b8b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88b8b7",
  null
  
)

export default component.exports